const BlueWorld = require('./blueworld')
/**
 * @typedef ClubCrawler.Parsers.Export
 * 
 *  
 * @property {ClubCrawler.Parser.BlueWorldParser} BlueWorld - The blueworld.json map loader
 * 
 */

module.exports = {
    BlueWorld: BlueWorld
};